import { getPublicRuntimeConfig } from '../../libs/init/getPublicRuntimeConfig';

/** App mount prefix (e.g. `/v2`). React Router 7 maps this to router basename config. */
export const getAppBasename = (): string => getPublicRuntimeConfig().paths.base;
